var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('checkbox',{attrs:{"editable":_vm.editable,"value":_vm.model.active},on:{"input":_vm.toggled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }